import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a66cb4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "content df aic jcsb" }
const _hoisted_3 = { class: "company-info df aic" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, null, -1))
const _hoisted_5 = { class: "el-dropdown-link" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("我的简历")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("投递记录")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("退出登录")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Login = _resolveComponent("Login")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.url)
            ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                style: {"height":"40px","width":"70px"},
                src: _ctx.url,
                fit: "fill"
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock(_component_el_image, {
                key: 1,
                style: {"height":"40px","width":"70px"}
              }, {
                error: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })),
          _createElementVNode("span", {
            style: {"cursor":"pointer"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toHome && _ctx.toHome(...args)))
          }, _toDisplayString(_ctx.companyName), 1)
        ]),
        (_ctx.hasToken)
          ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 0,
              onCommand: _ctx.handleCommand
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { command: "mycv" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { command: "record" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.$utils.mobileFm(_ctx.mobile)) + " ", 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onCommand"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              round: "",
              class: "login-btn",
              onClick: _ctx.login
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"]))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "手机号码登录",
      width: "400px",
      center: true,
      "destroy-on-close": true,
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Login, { successCallBack: _ctx.loginSuccess }, null, 8, ["successCallBack"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
}